<template>
    <v-app light>
        <v-navigation-drawer fixed :clipped="clipped" v-model="drawer" app>
            <div class="nav-header">
                <div style="font-weight: bold">{{ auth.user.name}} {{ auth.user.surname}}</div>
                <div>{{ auth.user.cell_no }}</div>
            </div>

            <v-list>
                <v-list-tile value="true" v-for="(item, i) in items" :key="i" exact :to="item.route" v-if="item.active && !item.share">
                    <v-list-tile-avatar class="dashboard-icon">
                        <img :src="item.img_menu">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>

        <v-toolbar fixed app :clipped-left="clipped" extended class="header-toolbar">
            <v-toolbar-side-icon :ripple="false" class="icon-light icon-drawer" @click.stop="drawer = !drawer"></v-toolbar-side-icon>

            <v-btn :ripple="false" color="#cc0000" absolute bottom right fab v-long-press="emergency" @click="showEmergencyMessage" v-if="config.modules.emergency">
                <img width="32" height="32" :src="require('../../../static/img/fab_ic_emergency.png')"/>
            </v-btn>
        </v-toolbar>
        <div id="header-image">
            <img :src="logo"/>
        </div>
        <v-content id="dashboard">
            <v-list three-line pa-0 light>
                <template v-for="(item, index) in items" v-if="item.dashboard && item.active">
                    <v-divider v-if="index !== 0"/>

                    <v-list-tile :key="item.title" avatar @click="" :to="item.route" class="dashboard-item" v-if="!item.share">
                        <v-list-tile-avatar class="dashboard-icon">
                            <img :src="item.img">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="dashboard-title" v-html="item.title"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile :key="item.title" avatar @click="executeShare" :to="item.route" class="dashboard-item" v-if="item.share">
                        <v-list-tile-avatar class="dashboard-icon">
                            <img :src="item.img">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="dashboard-title" v-html="item.title"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-content>
        <v-footer class="pa-3" v-if="config.modules.share">
            <v-spacer></v-spacer>
            Competition Entry Code:
            <strong style="color: maroon">{{ hashid }}</strong>
        </v-footer>
    </v-app>
</template>

<script>
    import Vue from 'vue'
    import {mapState, mapActions} from 'vuex'
    import vas from "@/lib/VASClient"
    import menu from "@/menu.js"

    import Hashids from 'hashids'

    var longpress = require('@/components/LongPress')
    Vue.use(longpress, {duration: 1000})

    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                hashid: '',
                version: '',
                clipped: false,
                drawer: false,
                items: menu,
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: config.app.name,
                config: config,
                logo: require('../../../variants/' + BUILD_VARIANT + '/logo.png'),
                share: config.share
            }
        },
        mounted() {
            var hashOf = parseInt(this.auth.user.user_id, 10);

            this.hashid = 'FD' + new Hashids('', 4, 'ABCDEFGHJKMNOPRSTUVWXYZ23456789').encode(hashOf);

            var self = this;
            if (window.cordova) {
                cordova.getAppVersion.getVersionNumber(function (version) {
                    self.version = version;
                });
            }
        },
        created() {
            window.EmergencySent = false;

            var self = this;

            if (typeof this.auth.user.terms_accepted !== "undefined" && parseInt(this.auth.user.terms_accepted) !== 1) {
                this.$router.push({name: 'unauthenticated.terms'});
                return;
            }

            var self = this;

            EventBus.$on('app-msg-received', function (message) {
                self.$router.push({name: 'authenticated.chat'})
            });

            Vue.cordova.on('deviceready', () => {
                if (!window.tokenSent) {
                    window.FirebasePlugin.onTokenRefresh(function (token) {
                        window.tokenSent = true;

                        vas.saveGcmKey(self.auth.user.user_id, self.auth.user.cell_no, token);
                    }, function (error) {
                    });
                }

                if (Vue.cordova.device.platform === 'Android') {
                    self.requestAndroidPermissions();
                }
            })
        },
        computed: {
            ...mapState(
                ['auth']
            )
        },
        methods: {
            executeShare() {
                var options = {
                    message: this.share.message, // not supported on some apps (Facebook, Instagram)
                    // subject: 'the subject', // fi. for email
                    // files: ['', ''], // an array of filenames either locally or remotely
                    // url: 'https://www.website.com/foo/#bar?a=b',
                    chooserTitle: 'Pick an app' // Android only, you can override the default share sheet title,
                    // appPackageName: 'com.apple.social.facebook' // Android only, you can provide id of the App you want to share with
                };

                window.plugins.socialsharing.shareWithOptions(options, function () {

                }, function () {
                });

                // navigator.share(this.share.message, this.share.title, 'text/plain');
            },
            showEmergencyMessage() {
                Snackbar.show("Press and hold the button to send an emergency notification");
            },
            emergency() {
                if (navigator.vibrate) {
                    navigator.vibrate(150);
                }

                this.$router.push({name: 'authenticated.emergency'})
            },
            requestAndroidPermissions() {
                var permissions = config.permissions;

                window.plugins.Permission.has(permissions, function (results) {
                    var toRequest = [];

                    for (var i in results) {
                        if (!results[i]) {
                            toRequest.push(i);
                        }
                    }

                    if (toRequest.length > 0) {
                        window.plugins.Permission.request(toRequest, function () {

                        }, function () {

                        });
                    }
                }, function (error) {
                    // navigator.app.exitApp()
                });
            },
        }
    }
</script>

<style>
    body {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
    }

    .footer { /* Apply this to v-bottom-nav if necessary. */
        margin-bottom: constant(safe-area-inset-bottom);
        margin-bottom: env(safe-area-inset-bottom);
    }

    .header-toolbar {
        /*background-image: url('../../../static/img/medi4u/header_bg.png');*/
        background-size: cover;
    }

    .dashboard-icon .v-avatar img {
        border-radius: 0;
    }

    .logo {
        /*border: 1px solid red;*/
        width: 100%;
        height: 100px;
        position: fixed;
        /*background-image: url('../../../static/img/medi4u/header_logo.png');*/
        background-position: center;
        background-size: contain;
        z-index: 10;
        padding: 10px;
        margin: 14px 0;
    }

    .icon-drawer {
        z-index: 15;
    }

    .v-list__tile__title {
        color: #333;
    }


</style>
